export const formatISO = (date: Date | null | undefined): string => {
  if (!date || Number.isNaN(date.getTime?.())) return "";
  const y = date.getUTCFullYear();
  const m = String(date.getUTCMonth() + 1).padStart(2, "0");
  const d = String(date.getUTCDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
};

export const parseISODate = (value: string | null | undefined): Date | null => {
  if (!value) return null;
  const parts = String(value).split("-");
  if (parts.length !== 3) return null;
  const [y, m, d] = parts.map((p) => parseInt(p, 10));
  if (!y || !m || !d) return null;
  const dt = new Date(Date.UTC(y, m - 1, d));
  return Number.isNaN(dt.getTime()) ? null : dt;
};

export const addMonths = (date: Date, delta: number): Date =>
  new Date(Date.UTC(date.getUTCFullYear(), date.getUTCMonth() + delta, 1));

export const formatDateLabel = (value: string | number | Date | null | undefined, locale = "nl-NL"): string => {
  if (value === null || value === undefined) return "";
  let dt: Date;
  if (typeof value === "number") {
    const ms = Math.abs(value) < 1e12 ? value * 1000 : value;
    dt = new Date(ms);
  } else if (typeof value === "string" && /^\d+$/.test(value.trim())) {
    const num = Number(value.trim());
    const ms = value.trim().length === 10 ? num * 1000 : num;
    dt = new Date(ms);
  } else {
    dt = new Date(value);
  }
  if (Number.isNaN(dt.getTime())) return "";
  return dt.toLocaleDateString(locale, { day: "2-digit", month: "short", year: "numeric" });
};

export const buildMonthDays = (anchor: Date) => {
  const year = anchor.getUTCFullYear();
  const month = anchor.getUTCMonth();
  const first = new Date(Date.UTC(year, month, 1));
  const startWeekday = first.getUTCDay();
  const daysInMonth = new Date(Date.UTC(year, month + 1, 0)).getUTCDate();
  const prevMonthDays = new Date(Date.UTC(year, month, 0)).getUTCDate();

  const cells: { date: Date; inMonth: boolean }[] = [];
  const leading = startWeekday === 0 ? 6 : startWeekday - 1;
  for (let i = leading; i > 0; i -= 1) {
    const day = prevMonthDays - i + 1;
    cells.push({ date: new Date(Date.UTC(year, month - 1, day)), inMonth: false });
  }
  for (let d = 1; d <= daysInMonth; d += 1) {
    cells.push({ date: new Date(Date.UTC(year, month, d)), inMonth: true });
  }
  while (cells.length % 7 !== 0) {
    const day = cells.length - (leading + daysInMonth) + 1;
    cells.push({ date: new Date(Date.UTC(year, month + 1, day)), inMonth: false });
  }
  return cells;
};

export const isSameDay = (a?: Date | null, b?: Date | null): boolean =>
  !!(
    a &&
    b &&
    a.getUTCFullYear() === b.getUTCFullYear() &&
    a.getUTCMonth() === b.getUTCMonth() &&
    a.getUTCDate() === b.getUTCDate()
  );

export const isBetween = (target: Date, start: Date | null, end: Date | null): boolean => {
  if (!start || !end) return false;
  const t = target.getTime();
  return t >= start.getTime() && t <= end.getTime();
};
